import { PersonImage, SliderNextIcconNew, SliderPreviousIcconNew } from "icons";
import { CaseCard } from "../case-card";
import styles from "./styles.module.scss";
import ReactQuill from "react-quill";
import { Carousel, Col, Popover, Row, Spin, Tooltip } from "antd";
import { AttachedFiles } from "../attached-files";
import { Cases } from "../cases";
import { useCurrentUserContext } from "providers";
import { UseApiCallV2 } from "hooks";
import { dateTimeFormatted } from "utils/helpers";
import { ConditionalRenderer } from "components";
import { CarouselSliderBtn } from "components/carouselNextBtn";
import { useRef, useState } from "react";
import { CasesList } from "./cases-list";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { NameInitials } from "components/name-initials";
import { getInitialLetters } from "utils/constants";

export const EmailDetail = ({ message_id, refetchEmails }) => {
  const { translator } = useLanguageTranslator();
  const emailNotesTrans = translator("emailNotes");
  const { user } = useCurrentUserContext();
  const sliderRef = useRef();
  const [currentSlide, setCurrentSlide] = useState(0);

  const {
    data: emailDetail,
    isLoading: emailDetailLoading,
    refetch: refetchEmailDetail,
  } = UseApiCallV2({
    url: "/get_email_detail",
    method: "POST",
    skip: !message_id,
    paramsData: {
      email: user?.email,
      message_id,
    },
  });
  const {
    data: emailAttachments,
    isLoading: emailAttachmentsLoading,
    refetch: refetchemailAttachments,
  } = UseApiCallV2({
    url: "/get_email_attachments",
    method: "POST",
    skip: !message_id,
    paramsData: {
      email: user?.email,
      message_id,
    },
  });

  const {
    subject,
    receivedDateTime,
    fromName,
    fromEmail,
    body,
    cc,
    recipients,
  } = emailDetail?.body || {};
  const { content } = body || {};
  const extractBody = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.innerHTML;
  };
  const finalContent = extractBody(content);

  const handlePrev = () => sliderRef?.current?.prev();

  const handleNext = () => sliderRef?.current?.next();

  const handleBeforeChange = (from, to) => {
    setCurrentSlide(to);
  };

  return (
    <Spin spinning={emailDetailLoading}>
      <ConditionalRenderer condition={currentSlide === 0}>
        <Tooltip title="Add Email to Note">
          <CarouselSliderBtn
            Icon={SliderNextIcconNew}
            handleClickBtn={handleNext}
            variant="next"
          />
        </Tooltip>
      </ConditionalRenderer>
      <ConditionalRenderer condition={currentSlide === 1}>
        <Tooltip title="Go Back to Cases">
          <CarouselSliderBtn
            Icon={SliderPreviousIcconNew}
            handleClickBtn={handlePrev}
            variant="prev"
          />
        </Tooltip>
      </ConditionalRenderer>
      <Carousel
        dots={false}
        ref={sliderRef}
        infinite={false}
        className={styles.carouselContainer}
        beforeChange={handleBeforeChange}
      >
        <div>
          <div style={{ padding: "20px 24px" }}>
            <h2 className={styles.title}>{emailNotesTrans.emailDescription}</h2>
            <div className={styles.firstSection}>
              <div className={styles.fields}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ width: "68%" }}>
                    <DisplayField label={emailNotesTrans.from}>
                      <div className={styles.fromData}>
                        <NameInitials name={fromName} size={41} />
                        <div className={styles.filedLabel}>{fromName}</div>
                        <div
                          className={styles.fromEmail}
                        >{`<${fromEmail}>`}</div>
                      </div>
                    </DisplayField>
                  </div>
                  <div style={{ width: "32%" }}>
                    <DisplayField label={emailNotesTrans.date}>
                      <div className={styles.filedLabel}>
                        {dateTimeFormatted(receivedDateTime)}
                      </div>
                    </DisplayField>
                  </div>
                </div>
                <DisplayField label={emailNotesTrans.to}>
                  <div className={styles.filedLabel}>
                    <MultipleEmails
                      emails={recipients}
                      emailNotesTrans={emailNotesTrans}
                    />
                  </div>
                </DisplayField>
                <DisplayField label="CC" variant="multipleEmails">
                  <div className={styles.filedLabel}>
                    <MultipleEmails
                      emails={cc}
                      emailNotesTrans={emailNotesTrans}
                    />
                  </div>
                </DisplayField>
                <DisplayField label={emailNotesTrans.subject}>
                  <div className={styles.filedLabel}>{subject}</div>
                </DisplayField>
              </div>
              <AttachedFiles
                files={emailAttachments?.body?.attachments}
                message_id={message_id}
                loading={emailAttachmentsLoading}
              />
            </div>
            <div className={styles.descriptionSection}>
              <DisplayField
                label={emailNotesTrans.description}
                minHeight="calc(51dvh - 100px)"
                alignItems="start"
              >
                <div
                  style={{ height: "100%", overflowY: "scroll", width: "100%" }}
                  dangerouslySetInnerHTML={{
                    __html: finalContent,
                  }}
                />
              </DisplayField>
              {/* <Cases /> */}
            </div>
          </div>
        </div>
        <div>
          <CasesList message_id={message_id} refetchEmails={refetchEmails} />
        </div>
      </Carousel>
    </Spin>
  );
};

function DisplayField({ children, label, minHeight, alignItems, variant }) {
  return (
    <div>
      <div className={styles.label}>{label}</div>
      <div className={styles.field} style={{ minHeight, alignItems }}>
        {children}
      </div>
    </div>
  );
}

function MultipleEmails({ emails, emailNotesTrans }) {
  const emailsToDisplayInField = Array.isArray(emails)
    ? emails?.slice(0, 2)
    : [];
  const emailsToDisplayInMoreSection = Array.isArray(emails)
    ? emails?.slice(2)
    : [];

  return (
    <>
      {emailsToDisplayInField?.join(" , ")}
      <ConditionalRenderer condition={emails?.length > 2}>
        <Popover
          placement="bottom"
          content={
            <div className={styles.moreEmails}>
              {emailsToDisplayInMoreSection?.map((item) => (
                <div>{item}</div>
              ))}
            </div>
          }
          trigger="click"
        >
          <span className={styles.moreBtn}>
            {" "}
            +{emailsToDisplayInMoreSection?.length} {emailNotesTrans.more}
          </span>
        </Popover>
      </ConditionalRenderer>
    </>
  );
}
